import React from 'react';
import { WardsData } from '../../Datas/WardsData';
import './WardInventoryModal.css';

const WardInventoryModal = ({ wardName, onClose }) => {
  const ward = WardsData.find((ward) => ward.wardName === wardName);

  if (!ward) {
    return null; 
  }

  const inventory = ward.inventory;

  return (
    <div className="ward-inventory-modal-overlay" onClick={onClose}>
      <div className="ward-inventory-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="ward-inventory-modal-title">Inventory for {ward.wardName}</h3>

        <table className="ward-inventory-table">
          <thead>
            <tr>
              <th>Medicine</th>
              <th>Stock Level</th>
              <th>Batch Number</th>
              <th>Expiry Date</th>
              <th>Cost</th>
              <th>Description</th>
              <th>Company</th>
            </tr>
          </thead>
          <tbody>
            {inventory.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.stockLevel}</td>
                <td>{item.batchNumber}</td>
                <td>{item.expiryDate}</td>
                <td>{item.cost}</td>
                <td>{item.description}</td>
                <td>{item.company}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <button className="ward-inventory-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default WardInventoryModal;
